import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Col, FormGroup, Label, Input, TabPane, Nav, NavItem, NavLink, TabContent} from 'reactstrap';
import Select from 'react-select';
import {TabelaCadastro} from "../components/TabelaCadastro";
import JustificativaParaContratacaoStore from "../stores/JustificativaContratacaoStore";
import * as classnames from "classnames";
import {createSelectOptions, inteiroPositivo} from "../../../utils/formatar";
import {getMotivoContratacaoById, justificativaAlocavelEnum, motivoContratacaoEnum} from "../../../utils/enums";
import {Validacao} from "../../comum/components/Validacao";

@inject("store")
@DataWrapper
@observer
export class CadastroJustificativaContratacao extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new JustificativaParaContratacaoStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Justificativa para contratação");

        this.controller.carregarLista();


        this.motivoContratacaoOptions = createSelectOptions(motivoContratacaoEnum, "id", "valor");
        this.justificativaAlocavelOptions = createSelectOptions(justificativaAlocavelEnum, "id", "valor");


    }

    /* modais (body e botões) */
    modalForm = () => {
        const booleanOptions = [{value: true, label: 'Sim'}, {value: false, label: 'Não'}];
        return(
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={classnames({ active: this.modal.activeTab === '1' })} onClick={() => { this.modal.setTab('1'); }}>
                            Principal
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.modal.activeTab === '2' })} onClick={() => { this.modal.setTab('2'); }}>
                            Prazos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.modal.activeTab === '3' })} onClick={() => { this.modal.setTab('3'); }}>
                            Quantidades
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.modal.activeTab}>
                    <br/>
                    <TabPane tabId="1">

                        <FormGroup row>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup check >
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()} />{' '}
                                        <Label>Ativo</Label>
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup>
                                    <Label>Nome da justificativa <sup>*</sup></Label>
                                    <Input type="text" maxLength={64} value={this.controller.itemSelecionado.nome} onChange={(event) => this.controller.setNome(event.target.value)} />
                                    <Validacao id="nome" valor={this.controller.itemSelecionado.nome} tipo={["isRequired"]} />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup>
                                    <Label>Descrição <sup>*</sup></Label>
                                    <Input type="textarea" maxLength={512} value={this.controller.itemSelecionado.descricao} onChange={(event) => this.controller.setDescricao(event.target.value)} />
                                    <Validacao id="descricao" valor={this.controller.itemSelecionado.descricao} tipo={["isRequired"]} />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12}>
                                <FormGroup>
                                    <Label>Motivo de contratação <sup>*</sup></Label>
                                    <Select simpleValue options={this.motivoContratacaoOptions} value={this.controller.itemSelecionado.motivoContratacao}
                                            onChange={(value) => this.controller.setMotivo(value)} multi={false} placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                                    <Validacao id="motivoContratacao" valor={this.controller.itemSelecionado.motivoContratacao} tipo={["isRequired"]} />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={6}>
                                <FormGroup>
                                    <Label>Classificação de risco <sup>*</sup></Label>
                                    <Input type="text" maxLength={32} value={this.controller.itemSelecionado.classificacaoRisco} onChange={(event) => this.controller.setClassificacaoRisco(event.target.value)} />
                                    <Validacao id="classificacaoRisco" valor={this.controller.itemSelecionado.classificacaoRisco} tipo={["isRequired"]} />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={6}>
                                <FormGroup>
                                    <Label>Exige aprovação diretor? <sup>*</sup></Label>
                                    <Input type="select" value={this.controller.itemSelecionado.exigeAprovacaoDiretor} onChange={(event) => this.controller.setExigeAprovacaoDiretor(event.target.value === "true")}>
                                        <option value={"true"}>Sim</option>
                                        <option value={"false"}>Não</option>
                                    </Input>
                                    <Validacao id="exigeAprovacaoDiretor" valor={this.controller.itemSelecionado.exigeAprovacaoDiretor} tipo={["isRequired"]} />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup>
                                    <Label>Justificativa alocável? <sup>*</sup></Label>
                                    <Select simpleValue  options={this.justificativaAlocavelOptions} value={this.controller.itemSelecionado.justificativaAlocavel}
                                            onChange={(value) => this.controller.setIsAlocavel(value)} multi={false}
                                            placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                                    <Validacao id="justificativaAlocavel" valor={this.controller.itemSelecionado.justificativaAlocavel} tipo={["isRequired"]} />
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.itemSelecionado.eventoImprevisivel} onChange={() => this.controller.toggleEventoImprevisivel()} />{' '}
                                        Justificativa está relacionada a um evento imprevisível
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.itemSelecionado.podeAlterarJustificativa} onChange={() => this.controller.toggleAlteraNaRenovacao()} />{' '}
                                        Permite alteração de justificativa na prorrogação
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.itemSelecionado.obrigatorioAlterar} onChange={() => this.controller.toggleObrigatorioAlterar()} />{' '}
                                        Obrigatório alterar justificativa na prorrogação
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.itemSelecionado.possuiFatoGerador} onChange={() => this.controller.toggleFatoGerador()} />{' '}
                                        Permite preencher fato gerador
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" checked={this.controller.itemSelecionado.produtoOracle} onChange={() => this.controller.toggleProdutoOracle()} />{' '}
                                        Considerar produto selecionado para custeio mensal
                                    </Label>
                                </FormGroup>
                            </Col>
                        </FormGroup>
                    </TabPane>

                    <TabPane tabId="2">
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6} />
                            <Col xs={3} md={3} lg={3} style={{textAlign: "center"}}>Mínimo</Col>
                            <Col xs={3} md={3} lg={3} style={{textAlign: "center"}}>Máximo</Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo para solicitação de substituição de MOT (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.solicSubstituicaoDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("solicSubstituicaoDiasMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.solicSubstituicaoDiasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("solicSubstituicaoDiasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo para solicitação de contratação (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.solicContratacaoDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("solicContratacaoDiasMin",inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.solicContratacaoDiasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("solicContratacaoDiasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Antecedência mínima para solicitar prorrogação em relação data fim (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.anteProrrogacaoDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("anteProrrogacaoDiasMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3} />
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo de vigência para permitir solicitação de término antecipado (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.solicTerminoAnteDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("solicTerminoAnteDiasMin", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo de contrato, incluindo renovações (dias)</Col>
                            <Col xs={3} md={3} lg={3} />
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.contRenovDiasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("contRenovDiasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo para prorrogação (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.prorrogacaoDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("prorrogacaoDiasMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.prorrogacaoDiasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("prorrogacaoDiasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo considerado ideal para início a partir da solicitação (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.iniSolicIdealDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("iniSolicIdealDiasMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.iniSolicIdealDiasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("iniSolicIdealDiasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Tempo considerado curto/limite para início a partir da solicitação (dias)</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.curtoIniSolicDiasMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("curtoIniSolicDiasMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.curtoIniSolicDiasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("curtoIniSolicDiasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                    </TabPane>
                    <TabPane tabId="3">
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6} />
                            <Col xs={3} md={3} lg={3} style={{textAlign: "center"}}>Mínimo</Col>
                            <Col xs={3} md={3} lg={3} style={{textAlign: "center"}}>Máximo</Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Recursos para solicitação de MOT</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.recursosSolicMotMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("recursosSolicMotMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.recursosSolicMotMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("recursosSolicMotMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Funcionários substituídos</Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.funcionariosSubstituidosMin} onChange={(event) => this.controller.setCampoJustificativaInteiro("funcionariosSubstituidosMin", inteiroPositivo(event.target.value))} /></Col>
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.funcionariosSubstituidosMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("funcionariosSubstituidosMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Funcionários para substituição sem requerer aprovação do diretor</Col>
                            <Col xs={3} md={3} lg={3} />
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.funcSubsSemAprovMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("funcSubsSemAprovMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Substituições permitidas</Col>
                            <Col xs={3} md={3} lg={3} />
                            <Col xs={3} md={3} lg={3}><Input type="number" value={this.controller.itemSelecionado.substituicoesPermitidasMax} onChange={(event) => this.controller.setCampoJustificativaInteiro("substituicoesPermitidasMax", inteiroPositivo(event.target.value))} /></Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col xs={6} md={6} lg={6}>Prorrogações permitidas</Col>
                            <Col xs={3} md={3} lg={3} />
                            <Col xs={3} md={3} lg={3}>
                                <Input className="incrementer" type="number"
                                       value={this.controller.itemSelecionado.prorrogacoesPermitidasMax}
                                       onChange={(event) => this.controller.setCampoJustificativaInteiro("prorrogacoesPermitidasMax", inteiroPositivo(event.target.value))}
                                />
                                <Validacao id="quantidadeProrrogacoesPermitidas"
                                           valor={this.controller.itemSelecionado.prorrogacoesPermitidasMax}
                                           tipo={["isRequired", "quantidadeMax", 99]}/>
                            </Col>
                        </FormGroup>
                    </TabPane>
                </TabContent>
            </div>
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nome;
    };

    obterConteudoMobile = (objeto) => {
        const ativo = objeto.ativo ? "Sim" : "Não"
        return (
            <div>
                { "Motivo de contratação: " + getMotivoContratacaoById(objeto.motivoContratacao).valor}<br/>
                { "Ativo: " + ativo}<br/>
            </div>
        )
    };

    motivoContratacaoFormat(cell) {
        return getMotivoContratacaoById(cell).valor
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "motivoContratacao",
                label: "Motivo de contratação",
                dataFormat: this.motivoContratacaoFormat
            },{
                field: "nome",
                label: "Nome da justificativa"
            },{
                field: "ativo",
                label: "Ativo",
                type: "boolean"
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Justificativa para contratação'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.justificativaList}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm()}
                            modalCadastrar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

